import React from 'react';
import { Link } from 'react-router-dom';
import './Portfolio.css';

// Portfolio data - Easy to add new applications here
const applications = [
  {
    id: 'utilities-notifier',
    title: 'Utilities Notifier',
    description: 'Stay informed about service interruptions and outages for essential utilities including electricity, water, and telecommunications. Real-time notifications keep communities and businesses prepared.',
    icon: '⚡',
    status: 'Live',
    features: [
      'Real-time outage notifications',
      'Service provider updates',
      'Scheduled maintenance alerts',
      'Community reporting'
    ],
    technologies: ['Python', 'Flask', 'React', 'MariadB'],
    link: null,
    externalLink: 'https://www.utilities-notifier.mndinitech.co.za'
  },
  {
    id: 'ezemali',
    title: 'Ezemali',
    description: 'Comprehensive financial management platform designed for businesses and individuals. Track expenses, manage budgets, generate financial reports, and gain insights into your financial health.',
    icon: '💰',
    status: 'Live',
    features: [
      'Expense tracking & categorization',
      'Budget management',
      'Invoice generation',
      'Financial reporting & analytics'
    ],
    technologies: ['Python', 'Flask', 'MySQL', 'React'],
    link: null,
    externalLink: 'https://www.ezemali.mndinitech.co.za'
  },
  {
    id: 'record-news',
    title: 'Record News',
    description: 'Advanced media monitoring platform that tracks news mentions, analyzes sentiment, and provides comprehensive coverage reports across multiple media channels.',
    icon: '📰',
    status: 'Live',
    features: [
      'Multi-channel media monitoring',
      'Sentiment analysis',
      'Custom alerts & notifications',
      'Comprehensive reporting'
    ],
    technologies: ['Python', 'Flask', 'Redis', 'PostgresSQL', 'React'],
    link: null,
    externalLink: 'https://www.recordnews.co.za'
  },
  {
    id: 'placement-hunter',
    title: 'Placement Hunter',
    description: 'South Africa\'s dedicated employment platform — connecting talent with opportunity, without the noise.',
    icon: '',
    status: 'Live',
    features: [
      'Purpose-Built',
      'POPIA Compliant',
      'Smart Matching',
      'Privacy Controls'
    ],
    technologies: ['Python', 'Flask', 'MariadB', 'React'],
    link: null,
    externalLink: 'https://www.placement-hunter.mndinitech.co.za'
  },
  {
    id: 'mndini-campaigns',
    title: 'Mndini Campaigns',
    description: 'Powerful survey and campaign management platform. Create, distribute, and analyze surveys with advanced analytics and insights to drive data-informed decisions.',
    icon: '📊',
    status: 'Live',
    features: [
      'Custom survey builder',
      'Multi-channel distribution',
      'Real-time analytics',
      'Export & reporting tools'
    ],
    technologies: ['Python', 'Flask', 'MySQL', 'React'],
    link: null,
    externalLink: 'https://www.mndini-campaigns.mndinitech.co.za'
  },
  {
    id: 'kumkani-mhlontlo-festival',
    title: 'Kumkani Mhlontlo Horse Racing Festival',
    description: 'Digital platform celebrating the annual horse racing festival in Qumbu. Features race schedules, horse profiles, live updates, photo galleries, and community engagement for this spectacular cultural event.',
    icon: '🏇',
    status: 'Live',
    features: [
      'Race schedules & results',
      'Horse & jockey profiles',
      'Live event updates',
      'Photo gallery & videos'
    ],
    technologies: ['React', 'Python', 'Flask', 'MySQL'],
    link: null,
    externalLink: 'https://www.kumkani-mhlontlo-festival.mndinitech.co.za'
  },
  {
    id: 'pro-cv-sports',
    title: 'Pro CV Sports',
    description: 'Digital platform built as a career archive for sports management businesses to showcase their talent.',
    icon: '📰',
    status: 'Live',
    features: [
      'Talents & Clubs',
      'News & Articles',
      'Player Profiles'
    ],
    technologies: ['React', 'Python', 'Flask', 'MySQL'],
    link: null,
    externalLink: 'https://www.pro-cv-sports.mndinitech.co.za'
  }
];

function Portfolio() {
  return (
    <div className="portfolio">
      {/* Hero Section */}
      <section className="portfolio-hero">
        <div className="container">
          <h1 className="fade-in">Our Portfolio</h1>
          <p className="portfolio-hero-subtitle fade-in">
            Innovative applications built to solve real-world challenges
          </p>
        </div>
      </section>

      {/* Applications Grid */}
      <section className="section section-light">
        <div className="container">
          <div className="section-title">
            <h2>In-House Applications</h2>
            <p>Proudly developed and maintained by our team</p>
          </div>

          <div className="applications-grid">
            {applications.map((app) => (
              <div key={app.id} className="application-card card">
                <div className="app-header">
                  <div className="app-icon">{app.icon}</div>
                  <span className={`app-status ${app.status.toLowerCase()}`}>
                    {app.status}
                  </span>
                </div>

                <h3>{app.title}</h3>
                <p className="app-description">{app.description}</p>

                <div className="app-features">
                  <h4>Key Features</h4>
                  <ul>
                    {app.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="app-tech">
                  <h4>Technologies</h4>
                  <div className="tech-tags">
                    {app.technologies.map((tech, index) => (
                      <span key={index} className="tech-tag">{tech}</span>
                    ))}
                  </div>
                </div>

                <div className="app-actions">
                  {app.externalLink ? (
                    <a 
                      href={app.externalLink} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="btn btn-primary"
                    >
                      Visit Application →
                    </a>
                  ) : (
                    <Link to={app.link} className="btn btn-primary">
                      Learn More →
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How to Add Section 
      <section className="section section-dark add-app-section">
        <div className="container">
          <div className="add-app-content">
            <h2>Adding New Applications</h2>
            <p>It's easy to add new applications to this portfolio page:</p>
            
            <div className="steps-grid">
              <div className="step-card">
                <div className="step-number">1</div>
                <h4>Open Portfolio.jsx</h4>
                <p>Navigate to src/pages/Portfolio.jsx in your code editor</p>
              </div>

              <div className="step-card">
                <div className="step-number">2</div>
                <h4>Add to Applications Array</h4>
                <p>Copy an existing application object and modify the details (lines 5-60)</p>
              </div>

              <div className="step-card">
                <div className="step-number">3</div>
                <h4>Update Information</h4>
                <p>Change title, description, features, technologies, and links</p>
              </div>

              <div className="step-card">
                <div className="step-number">4</div>
                <h4>Save & Refresh</h4>
                <p>Save the file and the new application card appears automatically</p>
              </div>
            </div>

            <div className="code-example">
              <h4>Example Application Object:</h4>
              <pre>
{`{
  id: 'my-new-app',
  title: 'My New Application',
  description: 'Brief description of what the app does...',
  icon: '🚀',
  status: 'Live', // or 'Beta', 'Coming Soon'
  features: [
    'Feature one',
    'Feature two',
    'Feature three'
  ],
  technologies: ['React', 'Python', 'MySQL'],
  link: '/portfolio/my-new-app',
  externalLink: 'https://myapp.com' // Optional
}`}
              </pre>
            </div>
          </div>
        </div>
      </section>*/}

      {/* CTA Section */}
      <section className="section cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Need a Custom Application?</h2>
            <p>
              Let's discuss how we can build a solution tailored to your specific needs.
            </p>
            <Link to="/contact" className="btn btn-primary">
              Start Your Project
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portfolio;
